import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import Dialog from "../../dialogs/Dialog";
import _ from "lodash";

/**
 * Edit text cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
let timeout = null;
export const editTextCell = ({ isValueChanged }) => {
  const EditTextCell = (props) => {
    const { onChange, dataItem, field, tdProps, isInEdit } = props;

    const gridValue = useMemo(() => _.get(dataItem, field.split(".")), [dataItem, field])
    const [value, setValue] = useState(gridValue || "");
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleDialogClose = () => {
      setIsDialogOpen(false);
    };

    const handleDialogOpen = () => {
      setIsDialogOpen(true);
    };

    const handleDialogConfirm = async (e) => {
      setIsDialogOpen(false);

      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e,
        value: value,
      });
    };

    const handleFocus = (e) => {
      e.target.selectionStart = 0;
      e.target.selectionEnd = e.target.value.length;
    };

    const handleTextAreaKeyDown = (e) => {
      if (e.key === "Enter") {
        e.stopPropagation();
      }
      if (e.key === "Escape") {
        setIsDialogOpen(false)
        e.stopPropagation();
      }
    };

    // const handleKeyDown = (e) => {
    //   var k = e.keyCode;
    //   if (e.ctrlKey || k === 8 || k === 9 || k === 13 || k === 27 || (k >= 16 && k <= 20) || (k >= 33 && k <= 40) || (k >= 44 && k <= 46)) {
    //     if (timeout) {
    //       clearTimeout(timeout);
    //       timeout = null;
    //       handleTimeout(new Event("change"));
    //       e.stopPropagation();
    //       setTimeout(() => {
    //         e.target.dispatchEvent(new KeyboardEvent("keydown", e));
    //       }, 500);
    //     }
    //     return;
    //   }
    // };

    const handleTimeout = (e, currentValue) => {
      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e,
        value: currentValue,
      });

      timeout = null;
    };

    const handleChange = (e) => {
      setValue(e.target.value)

      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      timeout = setTimeout(() => {
        handleTimeout(e, e.target.value);
      }, 300);
    };

    useEffect(() => {
      setValue(gridValue);
    }, [gridValue]);

    return <td {...tdProps} className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`} tabIndex={0}>
      {isInEdit === true ? (
        <input style={{ width: "100%" }}
          onChange={handleChange}
          // onKeyDown={handleKeyDown}
          className={"k-textbox"}
          value={value || ""}
          onDoubleClick={handleDialogOpen}
        />
      ) : (
        value
      )}
      {isDialogOpen && (
        <Dialog title={"Editácia textu"} isOpen={isDialogOpen} onClose={handleDialogClose} onConfirm={handleDialogConfirm}>
          <textarea
            className="k-textarea"
            value={value}
            onChange={(e) => { setValue(e.target.value) }}
            style={{ width: "100%" }}
            autoFocus={true}
            onFocus={handleFocus}
            onKeyDown={handleTextAreaKeyDown}
          />
        </Dialog>
      )}
    </td>
  };
  EditTextCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return EditTextCell;
};
